import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

import FlexColumn from '@ui/atoms/FlexColumn';

import theme from '@theme/FolxTheme';

import BasicText from '../BasicText';

export interface IHeaderCardProps {
	header: string;
	name: string;
	children?: ReactNode;
	className?: string;
	subheader?: string;
}

const Card = styled.div`
	align-items: center;
	border: 0.1rem solid ${theme.colors.black};
	border-radius: ${theme.radius.xl};
	display: flex;
	justify-content: space-between;
	gap: ${theme.spacing.sm};
	padding: ${theme.spacing.sm} ${theme.spacing.md};
`;

const CardContent = styled(FlexColumn)`
	flex-wrap: wrap;
`;

const HeaderCard: FC<IHeaderCardProps> = ({ children, className, header, subheader, name }) => {
	return (
		<Card className={className}>
			<CardContent>
				<BasicText variant="field">
					<label htmlFor={name}>{header}</label>
				</BasicText>
				{!!subheader && <BasicText variant="fineprint">{subheader}</BasicText>}
			</CardContent>
			{children}
		</Card>
	);
};

export default styled(HeaderCard)``;
